import api from './api';
import { Service, ServiceFormData, ServicesResponse, ServiceResponse } from '../types/Service';

export const serviceApi = {
  // Get all services
  async getServices(includeInactive: boolean = false): Promise<ServicesResponse> {
    const response = await api.get(`/services?includeInactive=${includeInactive}`);
    return response.data;
  },

  // Get services filtered by segments (for lead service assignment)
  async getServicesBySegments(segmentIds: number[]): Promise<ServicesResponse> {
    const response = await api.get(`/services?segmentIds=${segmentIds.join(',')}`);
    return response.data;
  },

  // Get single service
  async getService(id: number): Promise<ServiceResponse> {
    const response = await api.get(`/services/${id}`);
    return response.data;
  },

  // Create service
  async createService(data: ServiceFormData): Promise<ServiceResponse> {
    const response = await api.post('/services', data);
    return response.data;
  },

  // Update service
  async updateService(id: number, data: Partial<ServiceFormData>): Promise<ServiceResponse> {
    const response = await api.put(`/services/${id}`, data);
    return response.data;
  },

  // Archive service
  async archiveService(id: number): Promise<ServiceResponse> {
    const response = await api.post(`/services/${id}/archive`);
    return response.data;
  },

  // Restore archived service
  async restoreService(id: number): Promise<ServiceResponse> {
    const response = await api.post(`/services/${id}/restore`);
    return response.data;
  },

  // Reorder services
  async reorderServices(orders: Array<{ id: number; orderIndex: number }>): Promise<ServicesResponse> {
    const response = await api.post('/services/reorder', { serviceOrders: orders });
    return response.data;
  }
};

export default serviceApi;
